/* eslint-disable no-param-reassign */

const ensureUi = (state) => {
  if (!state.ui) {
    state.ui = {
      selectedChannelByProduct: {},
      activeTabByProductChannel: {},
      fetching: {
        listingAssets: {},
        listingVariantAssets: {},
        masterAssets: {},
        masterVariantAssets: {},
      },
      liveRefreshingByProductId: {},
      listingsLatestRequestId: {},
    };
  }

  if (!state.ui.selectedChannelByProduct) {
    state.ui.selectedChannelByProduct = {};
  }

  if (!state.ui.activeTabByProductChannel) {
    state.ui.activeTabByProductChannel = {};
  }

  if (!state.ui.fetching) {
    state.ui.fetching = {
      listingAssets: {},
      listingVariantAssets: {},
      masterAssets: {},
      masterVariantAssets: {},
    };
  }

  if (!state.ui.fetching.listingAssets) {
    state.ui.fetching.listingAssets = {};
  }

  if (!state.ui.fetching.listingVariantAssets) {
    state.ui.fetching.listingVariantAssets = {};
  }

  if (!state.ui.fetching.masterAssets) {
    state.ui.fetching.masterAssets = {};
  }

  if (!state.ui.fetching.masterVariantAssets) {
    state.ui.fetching.masterVariantAssets = {};
  }

  if (!state.ui.liveRefreshingByProductId) {
    state.ui.liveRefreshingByProductId = {};
  }

  if (!state.ui.listingsLoadingByProductId) {
    state.ui.listingsLoadingByProductId = {};
  }

  if (!state.ui.listingsLoadedByProductId) {
    state.ui.listingsLoadedByProductId = {};
  }

  if (!state.ui.listingsLatestRequestId) {
    state.ui.listingsLatestRequestId = {};
  }
};

export const setListingsLatestRequestId = (state, productId, requestId) => {
  if (!productId || !requestId) return;

  ensureUi(state);
  state.ui.listingsLatestRequestId[productId] = requestId;
};

export const isStaleListingsRequest = (state, productId, requestId) => {
  const latestRequestId = state.ui?.listingsLatestRequestId?.[productId];
  return Boolean(latestRequestId && latestRequestId !== requestId);
};

export const setListingsCardLoading = (state, productId, isLoading) => {
  if (!productId) return;

  ensureUi(state);

  if (isLoading) {
    if (state.ui.listingsLoadedByProductId[productId]) return;
    state.ui.listingsLoadingByProductId[productId] = true;
    return;
  }

  delete state.ui.listingsLoadingByProductId[productId];
};

export const setListingsCardLoaded = (state, productId) => {
  if (!productId) return;

  ensureUi(state);
  state.ui.listingsLoadedByProductId[productId] = true;
  delete state.ui.listingsLoadingByProductId[productId];
};

export const setLiveRefreshingByProduct = (state, productId, isRefreshing) => {
  if (!productId) return;

  ensureUi(state);

  if (isRefreshing) {
    state.ui.liveRefreshingByProductId[productId] = true;
    return;
  }

  delete state.ui.liveRefreshingByProductId[productId];
};

export const setListingAssetsFetching = (state, listingProductId, isFetching) => {
  if (!listingProductId) return;

  ensureUi(state);

  if (isFetching) {
    state.ui.fetching.listingAssets[listingProductId] = true;
    return;
  }

  delete state.ui.fetching.listingAssets[listingProductId];
};

export const setListingVariantAssetsFetching = (state, listingVariantId, isFetching) => {
  if (!listingVariantId) return;

  ensureUi(state);

  if (isFetching) {
    state.ui.fetching.listingVariantAssets[listingVariantId] = true;
    return;
  }

  delete state.ui.fetching.listingVariantAssets[listingVariantId];
};

export const setMasterAssetsFetching = (state, masterProductId, isFetching) => {
  if (!masterProductId) return;

  ensureUi(state);

  if (isFetching) {
    state.ui.fetching.masterAssets[masterProductId] = true;
    return;
  }

  delete state.ui.fetching.masterAssets[masterProductId];
};

export const setMasterVariantAssetsFetching = (state, masterVariantId, isFetching) => {
  if (!masterVariantId) return;

  ensureUi(state);

  if (isFetching) {
    state.ui.fetching.masterVariantAssets[masterVariantId] = true;
    return;
  }

  delete state.ui.fetching.masterVariantAssets[masterVariantId];
};

export const setSelectedChannelByProduct = (state, productId, channelId) => {
  if (!productId || channelId == null) return;

  ensureUi(state);
  state.ui.selectedChannelByProduct[productId] = channelId;
};

export const setActiveTabByProductChannel = (state, productId, channelId, tab) => {
  if (!productId || !channelId || tab == null) return;

  ensureUi(state);
  if (!state.ui.activeTabByProductChannel[productId]) {
    state.ui.activeTabByProductChannel[productId] = {};
  }
  state.ui.activeTabByProductChannel[productId][channelId] = tab;
};
